import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { ModalDecorator } from '../../ModalDecorator/ModalDecorator';

import './FeaturesModal.css';
import * as keyset from './FeaturesModal.i18n';
const i18n = i18nFactory(keyset);

export interface FeaturesModalProps {
    isVisible: boolean;
    onClose: () => void;
    operatorFeatures: string[];
    clientFeatures: string[];
}

const BLOCK = 'features-modal';

export class FeaturesModal extends React.Component<FeaturesModalProps> {
    render() {
        const { isVisible, onClose, operatorFeatures, clientFeatures } = this.props;

        return (
            <ModalDecorator cls={Bem.cls(BLOCK)} theme="default" visible={isVisible} onOutsideClick={onClose}>
                <div className={Bem.cls(BLOCK, 'title-client-features')}>{i18n('client-features')}</div>

                <div className={Bem.cls(BLOCK, 'content-client-features')}>
                    {this.renderFeaturesList(clientFeatures)}
                </div>

                <div className={Bem.cls(BLOCK, 'title-operator-features')}>{i18n('operator-features')}</div>

                <div className={Bem.cls(BLOCK, 'content-operator-features')}>
                    {this.renderFeaturesList(operatorFeatures)}
                </div>
            </ModalDecorator>
        );
    }

    private renderFeaturesList = (featureList: string[]) => {
        return (
            <div className={Bem.cls(BLOCK, 'features-list')}>
                {featureList.map((featureItem, index) => (
                    <div key={`features-item-${index}`} className={Bem.cls(BLOCK, 'features-item')}>
                        {featureItem}
                    </div>
                ))}
            </div>
        );
    };
}
